// extracted by mini-css-extract-plugin
export default {"bigger":"LogoVisa_bigger__vNrP7","textLogoVisa":"LogoVisa_textLogoVisa__ZJRTP","small":"LogoVisa_small__lU4tA","medium":"LogoVisa_medium__yy2R5"};